import $ from "cash-dom";

class KeyboardNavigation {
	constructor({ $rootLinks, closestSelectorToPreventToHideMenu, rootLinkContainerSelector }) {
		this._$rootLinks = $rootLinks;
		this._closestSelectorToPreventToHideMenu = closestSelectorToPreventToHideMenu;
		this._rootLinkContainerSelector = rootLinkContainerSelector;
	}

	init() {
		const self = this;
		self._isMouseDown = false;

		$(document).on('mousedown touchstart', function () {
			self._isMouseDown = true;
		});

		$(document).on('mouseup touchend', function () {
			setTimeout(() => {
				self._isMouseDown = false;
			}, 150);
		});

		$('a, button, select, input').on('focus', function () {
			// Only react to genuine keyboard focus changes. When focus comes from a
			// pointer/touch interaction (mousedown/touchstart), tapping a root link
			// would otherwise collapse the open dropdown mid-press — shifting layout
			// so the click lands outside the menu and closes it entirely (notably on
			// mobile). Click-driven open/close is handled in navigation.js instead.
			if (self._isMouseDown) {
				return;
			}

			const $el = $(this);

			if (!$el.closest(self._closestSelectorToPreventToHideMenu).length) {
				self._removeAllActiveClasses();
			}
		});

		self._$rootLinks.on('focus', function (e) {
			if (self._isMouseDown) {
				return;
			}
			const $navLink = $(this);

			self._addClassActive($navLink);
		});

		$(document).on('click', function (e) {
			const $el = $(e.target);

			if (!$el.hasClass('unfocusable-click')) {
				self._removeAllActiveClasses();
			}
		});
	}

	_addClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.addClass('active');
		$navLinkContainer.children('.sub-menu').addClass('active');
	}

	_removeClassActive($navLink) {
		if (!$navLink || !$navLink.length) {
			return;
		}

		const $navLinkContainer = this._rootLinkContainerSelector !== null
			? $navLink.closest(this._rootLinkContainerSelector)
			: $navLink;

		$navLinkContainer.removeClass('active');
		$navLinkContainer.children('.sub-menu').removeClass('active');
	}

	_removeAllActiveClasses() {
		this._$rootLinks.each((i, navLink) => {
			const $navLink = $(navLink);

			this._removeClassActive($navLink);
		});
	}
}

$(function () {
	const $navLinks = $('nav > ul.navbar-nav > li.nav-item > .nav-link');

	if ($navLinks.length) {
		(new KeyboardNavigation({
			$rootLinks: $navLinks,
			closestSelectorToPreventToHideMenu: '.sub-menu',
			rootLinkContainerSelector: 'li.nav-item',
		})).init();
	}

	const $filtersDropdowns = $('.filters-holder a.styleable-select-current');

	if ($filtersDropdowns.length) {
		(new KeyboardNavigation({
			$rootLinks: $filtersDropdowns,
			closestSelectorToPreventToHideMenu: '.styleable-select-list',
			rootLinkContainerSelector: '.styleable-select',
		})).init();
	}
});
